import React from 'react';
import clsx from 'clsx';

export type PillIntent =
  | 'accent'
  | 'ok'
  | 'warn'
  | 'danger'
  | 'info'
  | 'neutral';

export interface PillProps extends React.HTMLAttributes<HTMLSpanElement> {
  intent?: PillIntent;
}

const intentClasses: Record<PillIntent, string> = {
  accent: 'bg-accent-tint text-accent-text border-accent-border',
  ok: 'bg-ok-tint text-ok-text border-ok-border',
  warn: 'bg-warn-tint text-warn-text border-warn-border',
  danger: 'bg-danger-tint text-danger-text border-danger-border',
  info: 'bg-info-tint text-info-text border-info-border',
  neutral: 'bg-white/[0.08] text-slate-300 border-white/[0.08]',
};

export const Pill: React.FC<PillProps> = ({
  intent = 'neutral',
  className,
  children,
  ...props
}) => (
  <span
    className={clsx(
      'inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-[11px] font-medium',
      intentClasses[intent],
      className,
    )}
    {...props}
  >
    {children}
  </span>
);

export default Pill;
